import httpUtils from '../../utils/HttpUtils'

class CustomerVisitService {
  async list (onestopProjectId = '', ) {
    let result = null;
    try {
      result = await httpUtils.post('/customer/visit/list',{onestopProjectId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async save (customerVisit) {
    let result = null;
    try {
      result = await httpUtils.post('/customer/visit/save',customerVisit);
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

}
export default new CustomerVisitService()
